import { Scheduler } from '@livecontrol/scheduler/store';
import cx from 'classnames';
import type { HTMLAttributes, PropsWithChildren, ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { Store } from '../../../store';
import { EventsSection } from '../event-rows';
import type { Event } from '../store';

const Section = ({ children }: PropsWithChildren<unknown>): ReactElement => (
  <h2 className='mb-12px pb-12px border-bottom'>{children}</h2>
);

type Props = HTMLAttributes<HTMLDivElement> & {
  handleNoEvents: (isUpcoming: boolean, hide: boolean) => void;
};

const limitPage = 20;

export const Live = ({ className, handleNoEvents, ...props }: Props): ReactElement => {
  const [page, setPage] = useState(1);
  const [eventToScroll, setEventToScroll] = useState<Event[]>([]);

  const account = Store.Account.useAccount();

  const { events, refetch, loading } = Scheduler.Event.useEvents({
    event: {
      extra_filters: {
        page,
        limit: limitPage,
        client_id: account.id,
        date_lte: undefined,
        end_lte: undefined,
        end_gte: undefined,
        state: 'live'
      }
    }
  });

  const handleRefetch = (): void => {
    if (events && refetch && !loading && events.hasMore) {
      void refetch({
        event: {
          extra_filters: {
            page,
            limit: limitPage,
            client_id: account.id,
            date_lte: undefined,
            end_lte: undefined,
            end_gte: undefined,
            state: 'live'
          }
        }
      });
    }
  };

  const fetchMoreData = (): void => {
    handleRefetch();
    setPage((prevIndex) => prevIndex + 1);
  };

  useEffect(() => {
    if (events) {
      setEventToScroll((oldState) => {
        const newEvents = events.events ? [...oldState, ...events.events] : [...oldState];
        const mapIds = new Map<number, Event>();

        newEvents.forEach((obj) => {
          mapIds.set(obj.id, obj);
        });

        const newState = [...mapIds.values()];

        return [...newState];
      });
    }

    if (events?.events?.length === 0) {
      handleNoEvents(false, true);
    } else {
      handleNoEvents(false, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  return (
    <>
      {!!eventToScroll.length && <Section>Live Now</Section>}
      <div className={cx('mt-20px', className)} {...props}>
        {events && !!eventToScroll.length && (
          <EventsSection
            fetchMoreData={fetchMoreData}
            hasMore={events.hasMore ?? false}
            transformed={eventToScroll}
          />
        )}
      </div>
    </>
  );
};
